<template>
  <div>
    <figure class="hidden relative md:block md:h-[9.125rem]">
      <NuxtImg
        src="map/map-placeholder.svg"
        placeholder
        class="w-full h-full rounded-lg object-cover"
      />
      <figcaption
        class="absolute bottom-4 md:bottom-auto md:top-1/2 md:-translate-y-1/2 flex justify-center w-full"
      >
        <WebccButton
          variant="theme"
          class="!text-base py-2.5 !px-10 md:py-[0.4375rem] md:!px-3"
          :disabled="disabled"
          @click="toggle(true)"
        >
          {{ $t(`${trPrefixMap}viewMap`) }}
        </WebccButton>
      </figcaption>
    </figure>

    <WebccButton
      variant="theme"
      class="fixed bottom-12 left-1/2 z-5 h-11 -translate-x-1/2 rounded-full border-0 bg-thm px-4 text-sm font-semibold text-thm-contrast shadow-md hover:!bg-thm-hover focus:!bg-thm-hover md:hidden"
      :disabled="disabled"
      @click="toggle(true)"
    >
      {{ $t(`${trPrefixMap}viewMap`) }}
      <WebccIcon name="searchpage/frame" class="h-4 w-4 ml-2" />
    </WebccButton>

    <RedesignWebccDialog full-screen :open="isOpen" @close="toggle(false)">
      <template #title>
        <RedesignFilterButton v-model="model" class="-my-2" />
      </template>

      <template #default>
        <MapSearch
          :filters
          :viewport="searchResults.viewport"
          class="w-full h-full"
        />
      </template>
    </RedesignWebccDialog>
  </div>
</template>

<script setup lang="ts">
const trPrefixMap = 'www.map.'

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const model = defineModel<SearchState>({ required: true })

const [isOpen, toggle] = useToggle()
const tracking = useTracking()

const searchResults = useSearchResults(toReactive(model))

const filters = computed(() => mapSearchStateToSearchApiParams(model.value))

watch(isOpen, (value) => value && tracking.handlers?.search.mapView())
</script>
